import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { interval, Subject, switchMap, takeUntil, timer } from 'rxjs';
import { ApiService } from '../../../../../shared/services/api.service';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { CommonService } from '../../../../../shared/services/common.service';
import { ToastrService } from 'ngx-toastr';
import { AutofillmsmeService } from '../../../../../shared/services/autofillmsme.service';



@Component({
  selector: 'app-contactdetails',
  templateUrl: './contactdetails.component.html',
  styleUrl: './contactdetails.component.css'
})
export class ContactdetailsComponent {
  formData: any;
  data: MsmeData | null = null;
  udyamNumber: string | null = sessionStorage.getItem('udyamRegistrationNumber');
  isUdyamVerified: string | null = sessionStorage.getItem('isUdyamVerified');
  mobNum: string | null = sessionStorage.getItem('ownersMobileNumber');
  emailSession: string | null = sessionStorage.getItem('email');

  maxResendAttempts: number = 5;
  emailOtpTimer: number = 300;
  mobileOtpTimer: number = 300;
  emailOtpTimerRunning: boolean = false;
  mobileOtpTimerRunning: boolean = false;
  countdown: number = 300;
  countdownDisplay: string | undefined;
  isResendButtonDisabled: boolean = true;
  countdownSubject: Subject<void> = new Subject<void>();

  mobileResendCount = 1;
  emailResendCount = 1;


  isButtonDisabled: boolean = false;
  isButtonEmailDisabled: boolean = false;
  isButtonMobileDisabled: boolean = false;
  isVerifyButtonDisabled: boolean = false;

  emailOtpSent: boolean = false;
  mobileOtpSent: boolean = false;
  resendEmailOtpDisabled: boolean = true;
  resendMobileOtpDisabled: boolean = true;


  isVerifyEmailOtpButtonDisabled: boolean = true;
  isVerifyMobileOtpButtonDisabled: boolean = true;
  emailotpError: boolean = false;
  emailotpSuccess: boolean = false;
  otpError: boolean = false;
  otpSuccess: boolean = false;

  isMobOTPVerified: boolean = true;

  constructor(private router: Router, private apiService: ApiService, private commonService: CommonService, private toastrService: ToastrService,
    private route: ActivatedRoute, private msme_serv: AutofillmsmeService,) {

  }

  form = new FormGroup({
    ownersMobileNumber: new FormControl('', [Validators.required, Validators.pattern(this.commonService.mobilePattern)]),
    email: new FormControl('', [Validators.required, Validators.maxLength(40), Validators.pattern(this.commonService.emailPattern)]),
    mobotp: new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(6), Validators.pattern('^[0-9]+$')]),
    //emailotp: new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(6), Validators.pattern('^[0-9]+$')]),
  })

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.formData = history.state.formData;
      if (this.formData && this.formData.ownersMobileNumber) {
        //this.form.get('ownersMobileNumber')?.setValue(this.formData.ownersMobileNumber); //Uncomment this for PRod Release
        this.form.get('ownersMobileNumber')?.disable();
      }
    });

    this.countdownSubject.asObservable()
      .pipe(
        switchMap(count => timer(0, 1000))
      )
      .subscribe(count => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          this.isResendButtonDisabled = false;
          this.countdownSubject.complete();
        }
      });

    if (this.isUdyamVerified === 'true') {
      this.fetchMsmeData();
    } else {
      this.form.get('email')?.enable();
    }

    this.form.get('mobotp')?.valueChanges.subscribe(() => {
      this.toggleVerifyButtons("mobile");
    });

    // Subscribe to value changes for email OTP
    //this.form.get('emailotp')?.valueChanges.subscribe(() => {
    //  this.toggleVerifyButtons("email");
    //});
  }

  //This method is used for Autofill.json
  //async fetchMsmeData() {
  //  if (this.udyamNumber) {
  //    try {
  //      this.data = await this.msme_serv.getDataByUdyamNumber(this.udyamNumber);

  //      if (this.data) {
  //        this.form.get('email')?.setValue(this.data.email);
  //        this.form.get('email')?.disable();
  //      }
  //    } catch (error) {
  //      console.error('Error fetching MSME data:', error);
  //      this.toastrService.error('Failed to load MSME data', 'Error');
  //    }
  //  }
  //}

  //This method is used for Udyam API Integration
  async fetchMsmeData() {
    const dtoUdyam = {
      authToken: "",
      clientId: "",
      udyamNo: this.udyamNumber,
      mobile: this.mobNum
    }
    this.apiService.postRequest(API_ENDPOINTS.UDYAM.VERIFYUDYAM, dtoUdyam).subscribe(
      response => {
        if (response.isResponse === 'Y') {
          //this.form.get('ownersMobileNumber')?.setValue('7021263138');// Mr. Hitesh- Security Audit
          //this.form.get('ownersMobileNumber')?.setValue('8799974825');
          this.form.get('ownersMobileNumber')?.setValue(this.mobNum);//uncomment for Prod

          this.form.get('ownersMobileNumber')?.disable();
          //this.form.get('email')?.setValue('hitesh.balani@mahait.org');// Mr. Hitesh- Security Audit
          //this.form.get('email')?.setValue('mssidc@yopmail.com');
          this.form.get('email')?.setValue(this.emailSession);//uncomment for prod
          this.form.get('email')?.disable();
        }
      });
  }

  get f() {
    return this.form.controls;
  }

  SendOTP() {
    const formValues = this.form.getRawValue();
    if (!formValues.email) {
      this.toastrService.error('Please enter a valid email.');
      this.isButtonDisabled = false;
      return;
    }

    this.isButtonMobileDisabled = true;
    const otpdata =
    {
      otpType: 'mobile',
       otpValue: this.form.controls.ownersMobileNumber.value
    // otpValue: '8976557045'
      
    }
    this.apiService.postRequest(API_ENDPOINTS.Otp.SendOtp, otpdata).subscribe(
      res => {
        if (res.status) {
          this.toastrService.success(res.message);
          this.mobileOtpSent = true;
          this.isVerifyMobileOtpButtonDisabled = false;  // Enable Verify button after OTP sent
          this.startMobileOtpTimer();
        }
        //else {
        //  alert('Entered Mobile OTP is incorrect. Please enter correct OTP');
        //  this.isButtonMobileDisabled = false; 
        //}
      });
  }

  ReSendMobileOTP() {
    const formValues = this.form.getRawValue();
    if (!formValues.ownersMobileNumber) {
      this.toastrService.error('Please enter a valid email.');
      this.isButtonDisabled = false;
      return;
    }

    if (this.mobileResendCount >= this.maxResendAttempts) {
      this.toastrService.warning('You have reached the maximum resend attempts for mobile OTP today.', 'Warning');
      return;
    }

    this.mobileResendCount++;
    this.isButtonMobileDisabled = true;

    const otpdata = {
      otpType: 'mobile',
       otpValue: this.form.controls.ownersMobileNumber.value
      //  otpValue: '8976557045'
    };

    this.apiService.postRequest(API_ENDPOINTS.Otp.SendOtp, otpdata).subscribe(res => {
      if (res.status) {
        this.resetCountdown();
        this.startMobileOtpTimer();
      } else {
        alert('Error... Please try after sometime!!');
        this.isButtonMobileDisabled = false;
      }
    });
  }

  //SendEmailOTP() {
  //  const formValues = this.form.getRawValue();
  //  if (!formValues.email) {
  //    this.toastrService.error('Please enter a valid email.');
  //    this.isButtonDisabled = false;
  //    return;
  //  }

  //  this.form.get('email')?.disable();
  //  this.isButtonEmailDisabled = true;
  //  const emailotpdata =
  //  {
  //    otpType: 'email',
  //    otpValue: this.form.controls.email.value
  //  }
  //  this.apiService.postRequest(API_ENDPOINTS.Otp.SendOtp, emailotpdata).subscribe(
  //    res => {
  //      if (res.status) {
  //        this.toastrService.success(res.message);
  //        this.emailOtpSent = true;
  //        this.isVerifyEmailOtpButtonDisabled = false;
  //        this.startEmailOtpTimer();
  //      }
  //      else {
  //        alert('Entered  OTP is incorrect. Please enter correct OTP');
  //        this.isButtonEmailDisabled = false;
  //      }
  //    });
  //}

  //ReSendEmailOTP() {
  //  const formValues = this.form.getRawValue();
  //  if (!formValues.email) {
  //    this.toastrService.error('Please enter a valid email.');
  //    this.isButtonDisabled = false;
  //    return;
  //  }
  //  this.form.get('email')?.disable();
  //  if (this.emailResendCount >= this.maxResendAttempts) {
  //    this.toastrService.warning('You have reached the maximum resend attempts for email OTP today', 'Warning');
  //    return;
  //  }
  //  this.emailResendCount++;
  //  this.isButtonEmailDisabled = true;

  //  const emailotpdata = {
  //    otpType: 'email',
  //    otpValue: this.form.controls.email.value
  //  };

  //  this.apiService.postRequest(API_ENDPOINTS.Otp.SendOtp, emailotpdata).subscribe(res => {
  //    if (res.status) {
  //      this.toastrService.success(res.message);
  //      this.startEmailOtpTimer();
  //      this.isVerifyEmailOtpButtonDisabled = false;
  //      this.resetCountdown();
  //      this.isButtonDisabled = true;
  //    } else {
  //      alert('Error... Please try after sometime!!');
  //      this.isButtonEmailDisabled = true;
  //    }
  //  });
  //}




  verifyMobileOtp() {
    const otpdata = {
      OtpType: 'mobile',
       OtpValue: this.form.controls.ownersMobileNumber.value,
          // otpValue: '8976557045',
      Otp: this.form.controls.mobotp.value?.toString()

      

      
    };

    this.apiService.postRequest(API_ENDPOINTS.Otp.VerifyOtp, otpdata).subscribe(
      (res) => {
        /*if (res.status)*/
        if (res.message === "OTP verified successfully.") {
          this.toastrService.success(res.message);
          this.otpError = false;
          this.otpSuccess = true;
          this.resendMobileOtpDisabled = true;
          this.stopMobileOtpTimer();

          this.isVerifyMobileOtpButtonDisabled = true;
          this.form.controls.mobotp.disable(); // Disable the field to make it readonly
          this.isVerifyMobileOtpButtonDisabled = true;
        } else {
          this.otpError = true;
          this.otpSuccess = false;
        }
      },
      (error) => {
        console.error('Error during mobile OTP verification:', error);
        this.toastrService.error("Entered Mobile OTP is incorrect. Please enter correct OTP");
        this.otpError = true;
        this.otpSuccess = false;
      }
    );
  }



  //verifyEmailOtp() {
  //  const emailotpdata = {
  //    OtpType: 'email',
  //    OtpValue: this.form.controls.email.value,
  //    Otp: this.form.controls.emailotp.value?.toString()
  //  };

  //  this.apiService.postRequest(API_ENDPOINTS.Otp.VerifyOtp, emailotpdata).subscribe(
  //    (res) => {
  //      /*if (res.status)*/
  //      if (res.message === "OTP verified successfully.") {
  //        this.toastrService.success(res.message);
  //        this.emailotpError = false;
  //        this.emailotpSuccess = true;
  //        this.resendEmailOtpDisabled = true;
  //        this.stopEmailOtpTimer();
  //        this.isVerifyEmailOtpButtonDisabled = true;
  //        this.form.controls.emailotp.disable();
  //        this.isVerifyEmailOtpButtonDisabled = true;
  //      } else {
  //        this.emailotpError = true;
  //        this.emailotpSuccess = false;
  //      }
  //    },
  //    (error) => {
  //      console.error('Error during email OTP verification:', error);
  //      this.toastrService.error("Entered Email OTP is incorrect. Please enter correct OTP");
  //      this.emailotpError = true;
  //      this.emailotpSuccess = false;
  //    }
  //  );
  //}

  startMobileOtpTimer() {
    this.mobileOtpTimerRunning = true;
    this.mobileOtpTimer = 300;
    this.resendMobileOtpDisabled = true;

    const mobileTimer = setInterval(() => {
      if (this.mobileOtpTimer > 0) {
        this.mobileOtpTimer--;
      } else {
        clearInterval(mobileTimer);
        this.mobileOtpTimerRunning = false;
        this.resendMobileOtpDisabled = false;
      }
    }, 1000);
  }

  //startEmailOtpTimer() {
  //  this.emailOtpTimerRunning = true;
  //  this.emailOtpTimer = 300;
  //  this.resendEmailOtpDisabled = true;

  //  const emailTimer = setInterval(() => {
  //    if (this.emailOtpTimer > 0) {
  //      this.emailOtpTimer--;
  //    } else {
  //      clearInterval(emailTimer);
  //      if (this.isUdyamVerified === 'true') {
  //        this.form.get('email')?.disable();
  //      } else {
  //        this.form.get('email')?.enable();
  //      }

  //      this.emailOtpTimerRunning = false;
  //      this.resendEmailOtpDisabled = false;
  //    }
  //  }, 1000);
  //}

  stopMobileOtpTimer() {
    this.mobileOtpTimerRunning = false;
    this.resendMobileOtpDisabled = true;
    clearInterval(this.mobileOtpTimer); // Stop the mobile timer
  }

  //stopEmailOtpTimer() {
  //  this.emailOtpTimerRunning = false;
  //  this.resendEmailOtpDisabled = true;
  //  clearInterval(this.emailOtpTimer); // Stop the email timer
  //}

  resetCountdown() {
    this.stopCountdown();
    this.startResendCountdown();
  }

  startResendCountdown() {
    this.isResendButtonDisabled = true;
    this.countdown = 300;
    interval(1000).pipe(takeUntil(this.countdownSubject)).subscribe(() => {
      if (this.countdown > 0) {
        this.countdown--;
        this.updateCountdownDisplay();
      } else {
        this.stopCountdown();
      }
    });
  }

  updateCountdownDisplay() {
    const minutes = Math.floor(this.countdown / 60);
    const seconds = this.countdown % 60;
    this.countdownDisplay = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  }


  onReset() {
    this.form.reset();
    sessionStorage.clear();
    this.router.navigateByUrl('/login');
  }

  stopCountdown() {
    this.countdown = 0;
    this.isResendButtonDisabled = true;
    this.countdownSubject.complete();
  }

  getFormValuesIncludingDisabled() {
    const formValues = this.form.getRawValue();
    return {
      email: formValues.email,
      ownersMobileNumber: formValues.ownersMobileNumber
    };
  }

  toggleVerifyButtons(type: string) {

    if (type === "mobile") {
      this.isVerifyMobileOtpButtonDisabled = this.form.get('mobotp')?.value?.length !== 6;
    }
    //else if (type === "email") {

    //  this.isVerifyEmailOtpButtonDisabled = this.form.get('emailotp')?.value?.length !== 6;
    //}

  }

  goto(form: any) {
    if (!this.otpSuccess) {
      this.toastrService.error("Please verify OTP");
      return;
    }
    /*if (form.valid)*/
    if(form.controls.email.value && form.controls.mobotp.value && form.controls.ownersMobileNumber.value)
    {
      const formdatavalue = {
        udyamRegistrationNumber: this.formData.udyamRegistrationNumber,
        ...this.getFormValuesIncludingDisabled(),
      };
      if (this.isUdyamVerified === 'false') {
        sessionStorage.setItem("email", form.controls.email.value);
        sessionStorage.setItem("ownersMobileNumber", form.controls.ownersMobileNumber.value);
      }
      sessionStorage.setItem('contactDetailsCompleted', 'true');
      this.toastrService.success('Your information is saved successfully.')
      this.router.navigate(['/credentialdetails'], { state: { formData: formdatavalue } });
    } else {
      this.form.markAllAsTouched();
      return;
    }
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}

interface MsmeData {
  email: string;
  ownersMobileNumber: string;
}
